import { render, staticRenderFns } from "./UPSThreePhaseVoltage.vue?vue&type=template&id=58d5bccc&scoped=true&"
import script from "./UPSThreePhaseVoltage.vue?vue&type=script&lang=js&"
export * from "./UPSThreePhaseVoltage.vue?vue&type=script&lang=js&"
import style0 from "./UPSThreePhaseVoltage.vue?vue&type=style&index=0&id=58d5bccc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5bccc",
  null
  
)

export default component.exports